/**
 * Get the icon properties for the Customer Review Agent icon based on the risk level
 *
 * @param {string} riskLevel - The risk level of the agent report
 * @param {string} status - The status of the agent report
 * @returns {object} - The icon properties
 */
export function getAgentIconProperties(riskLevel, status) {
  const properties = {
    symbol: '',
    type: '',
  };

  if (status === 'RUNNING' || status === 'FAILED') {
    properties.symbol = 'medium-user-profile-focus';
    properties.type = 'primary';
    return properties;
  }

  switch (riskLevel) {
    case 'LOW':
      properties.symbol = 'small-check-1';
      properties.type = 'success';
      break;
    case 'MEDIUM':
      properties.symbol = 'small-alert-circle';
      properties.type = 'warning';
      break;
    case 'HIGH':
      properties.symbol = 'small-alert-triangle';
      properties.type = 'error';
      break;
    case 'NOT_APPLICABLE':
      properties.symbol = 'small-info-circle';
      properties.type = 'neutral';
      break;
  }

  return properties;
}

/**
 * Format the Customer Review Agent "risk level" string
 *
 * @param {string} riskLevel - The risk level value
 * @returns {string} - The formatted risk level string
 */

export function formatAgentRiskLevel(riskLevel) {
  if (!riskLevel) return '';

  if (riskLevel === 'NOT_APPLICABLE') {
    return 'Not Applicable';
  }

  return (
    riskLevel.charAt(0).toUpperCase() +
    riskLevel.slice(1).toLowerCase() +
    ' Risk'
  );
}

/**
 * Format the Customer Review Agent "confidence" string
 *
 * @param {string} confidence - The confidence value
 * @param {string} riskLevel - The risk level value
 * @returns {string} - The formatted confidence string
 */

export function formatAgentConfidence(confidence, riskLevel) {
  if (!confidence) return '';

  if (riskLevel === 'NOT_APPLICABLE') {
    return 'Customer failed visual checks';
  }

  return 'Confidence level ' + confidence.toLowerCase();
}
